import React from 'react';

function ServicesShowcase() {
    const services = [
        {
            number: '01',
            title: 'Customer Care & Reputation Management',
            icon: '💬',
            description: 'Building high-performance customer care systems with seamless cross-platform functionality. Delivering immersive guest recovery experiences.',
            tags: ['24/7 Support', 'Multilingual', 'Review Management', 'WhatsApp'],
            features: [
                '95% response rate within 24 hours (we hit our SLAs)',
                'Hotels that respond to reviews see 12% higher ratings',
                'Going from 4.2 to 4.6 adds $78K annually'
            ],
            link: 'customer-care.html'
        },
        {
            number: '02',
            title: 'Complete OTA Management',
            icon: '📊',
            description: 'Stop losing margins to OTA commissions. We optimize your listings daily, maintain rate parity, and manage strategic pricing to maximize every booking.',
            tags: ['Rate Parity', 'Booking.com', 'Revenue Optimization', 'PMS Integration'],
            features: [
                '98%+ parity uptime (daily checks, instant corrections)',
                'Direct bookings 35% → 55% in 8 months = $110K saved',
                'Ranking improved from #11 to #3 on Booking.com'
            ],
            link: 'ota-management.html'
        },
        {
            number: '03',
            title: 'Social Media That Sells',
            icon: '📱',
            description: 'Transform your social channels into direct-booking engines. Automated posting, occupancy-triggered flash sales, and geo-targeted campaigns.',
            tags: ['Instagram', 'TikTok', 'Facebook', 'Content Creation'],
            features: [
                '12-16 posts monthly across Instagram, TikTok, Facebook',
                'Comment & DM triage within 12 hours',
                'User-generated content curation & reposting'
            ],
            link: 'social-media.html'
        },
        {
            number: '04',
            title: 'Email Marketing & Corporate Outreach',
            icon: '📧',
            description: 'Replace passive marketing with proactive revenue generation. Targeted campaigns for past guests, personalized cold outreach to corporate clients.',
            tags: ['Email Campaigns', 'Corporate Sales', 'AI Personalization', 'Event Planning'],
            features: [
                '2-4 campaigns monthly | 25%+ open rate | 3%+ CTR',
                '20% booking conversion improvement',
                'Corporate pipeline prospecting with AI personalization'
            ],
            link: 'email-marketing.html'
        },
        {
            number: '05',
            title: 'Mobile App Development',
            icon: '📱',
            description: 'Building high-performance mobile applications with seamless cross-platform functionality. Delivering immersive AR experiences and AI-powered features.',
            tags: ['API Integration', 'Flutter', 'Kotlin', 'Room'],
            features: [
                'Mobile bookings = 60%+ of reservations',
                'Load time <2.5 seconds | 53% abandon sites >3 seconds',
                '30% conversion rate improvement when optimized'
            ],
            link: 'software-development.html'
        },
        {
            number: '06',
            title: 'Recruiting & Talent Pipeline',
            icon: '👥',
            description: 'End the hiring headache. Multi-platform candidate sourcing, structured interview processes, streamlined onboarding, and retention tracking.',
            tags: ['Talent Sourcing', 'Onboarding', 'Retention', 'HR Analytics'],
            features: [
                'Industry average: 73% turnover | Crisis properties: 180%',
                'You\'re spending $200K+ annually on people who quit in 3 months',
                '180% turnover reduced to 65% in 12 months = $220K saved'
            ],
            link: 'recruiting.html'
        }
    ];

    return (
        <section id="services" className="services-showcase">
            <div className="section-content">
                <h2 className="section-title">
                    Everything Your <span className="highlight">Hotel</span> Needs. <span className="highlight">One Platform</span>.
                </h2>
                <p style={{ 
                    textAlign: 'center', 
                    fontSize: '1.3rem', 
                    maxWidth: '1000px', 
                    margin: '0 auto 3rem', 
                    color: 'var(--text-secondary)', 
                    lineHeight: '1.8', 
                    fontWeight: '400' 
                }}>
                    From the moment a guest discovers you online to the second they leave a glowing review every touchpoint, every system, every team member connected in real-time. This isn't software. It's your complete operating system.
                </p>
                
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <div className="service-card-header">
                                <div className="service-icon">
                                    {service.icon || '📱'}
                                </div>
                                <div className="service-number">{service.number}</div>
                                <div className="service-rating">5-Star Rating</div>
                            </div>
                            <h3 className="service-title">{service.title}</h3>
                            <p className="service-desc">{service.description}</p>
                            {service.tags && service.tags.length > 0 && (
                                <div className="service-tags">
                                    {service.tags.map((tag, tagIndex) => (
                                        <span key={tagIndex} className="service-tag">{tag}</span>
                                    ))}
                                </div>
                            )}
                            {service.features && service.features.length > 0 && (
                                <ul className="service-features">
                                    {service.features.slice(0, 3).map((feature, featureIndex) => (
                                        <li key={featureIndex}>
                                            <span className="feature-check">✓</span>
                                            <span>{feature.includes('<strong>') ? (
                                                <span dangerouslySetInnerHTML={{ __html: feature }} />
                                            ) : (
                                                <span>{feature}</span>
                                            )}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <a 
                                href={service.link} 
                                className="learn-more-btn"
                            >
                                Explore {service.title.includes('Development') ? 'Development' : service.title.split(' ').slice(-1)[0]} →
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServicesShowcase;

